/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ArticoloPraticaStatus } from './articolo-pratica-status';


export interface VoucherArticoloDTO { 
    id?: string;
    titolo?: string;
    valore?: number;
    stato?: ArticoloPraticaStatus;
    version?: number;
}



